const en = {
  menu: {
    view: "View",
    suggest: "Suggest",
    admin: "Admin",
    user: "User",
    filter: "Filter",
    search: "Filter",
    import_menu: "Import",
    export: "Export",
    stamp: "Stamp",
    set: "Set",
    block: "Block",
    booklet: "Booklet",
    seTenants: "SeTenants",
    deleteDatabase: "Delete Database",
    exportAdmin: "Export",
    importAdmin: "Import",
    dumpToConsole: "Dump to Console",
    userDashboard: "User Dashboard",
    help: "Help",
    login: "Login",
    logout: "logout",
    changeUser: "Change User",
    role: "Role: ",
  },
  userDashboard: {
    title: "User Dashboard",
    description: "Overview of all users and their activity.",
    name: "Name",
    email: "Email",
    role: "Role",
    id: "ID",
    loading: "Loading…",
    error: "Failed to load user data.",
  },
  userDetail: {
    title: "User Details",
    description: "Activity summary for this user.",
    loading: "Loading…",
    error: "Failed to load user details.",
    suggestions: "Suggestions",
    suggestionsTotal: "Total",
    accepted: "Accepted",
    rejected: "Rejected",
    inReview: "In Review",
    notInReview: "Not in Review yet",
    reviews: "Reviews",
    reviewsTotal: "Total",
  },
  errors: {
    postStampSuggestion: "Error while posting single stamp suggestion: ",
    postSetSuggestion: "Error while posting philatelic set suggestion: ",
    postBlockSuggestion: "Error while posting block suggestion: ",
    postBookletSuggestion: "Error while posting booklet suggestion: ",
    postSeTenantsSuggestion: "Error while posting se-tenants suggestion: ",
    dumpToConsole: "Error while dumping to console: ",
    deleteAll: "Error while deleting all items and suggestions: ",
    markAsInReview: "Failed to mark as In Review: ",
    reviewFailed: "Review failed: ",
    importItems: "Error while importing philatelic items: ",
    deleteSuggestion: "Failed to delete suggestion: ",
    deleteUser: "Failed to delete user: ",
  },
  login: {
    title: "Login",
    description: "Please enter your email and password.",
    email: "Email",
    password: "Password",
    button: "Login",
    cancel: "Cancel",
  },
  import: {
    title: "Import",
    description: "Review the contents of a data file and import it into the database.\nNote that this will overwrite all existing items.",
    dataFile: "Data File",
    numberOfEntries: "Number of entries",
    notAvailable: "N/A",
    button: "Import",
    importing: "Importing …",
    close: "Close",
    done: "Import complete.",
  },
  editor: {
    /** Joins a details/review subtitle to the name of the contributor who suggested the item. */
    suggestedBy: "by",
    stampEditorTitle: "Stamp Editor",
    stampEditorSubtitle: "Create a Stamp Suggestion",
    stampDetailsTitle: "Stamp Details",
    stampDetailsSuggestionSubtitle: "Details of a Stamp Suggestion",
    stampDetailsCatalogSubtitle: "Details of a Stamp from the catalogue",
    stampReviewTitle: "Stamp Review Editor",
    stampReviewSubtitle: "Modify and Review a Suggestion",
    setEditorTitle: "Set Editor",
    setEditorSubtitle: "Create a Set Suggestion",
    setDetailsTitle: "Set Details",
    setDetailsSuggestionSubtitle: "Details of a Set Suggestion",
    setDetailsCatalogSubtitle: "Details of a Set from the catalogue",
    setReviewTitle: "Set Review Editor",
    setReviewSubtitle: "Modify and Review a Suggestion",
    blockEditorTitle: "Block Editor",
    blockEditorSubtitle: "Create a Block Suggestion",
    blockDetailsTitle: "Block Details",
    blockDetailsSuggestionSubtitle: "Details of a Block Suggestion",
    blockDetailsCatalogSubtitle: "Details of a Block from the catalogue",
    blockReviewTitle: "Block Review Editor",
    blockReviewSubtitle: "Modify and Review a Suggestion",
    addBlockSuggestion: "Add Suggestion",
    bookletEditorTitle: "Booklet Editor",
    bookletEditorSubtitle: "Create a Booklet Suggestion",
    bookletDetailsTitle: "Booklet Details",
    bookletDetailsSuggestionSubtitle: "Details of a Booklet Suggestion",
    bookletDetailsCatalogSubtitle: "Details of a Booklet from the catalogue",
    bookletReviewTitle: "Booklet Review Editor",
    bookletReviewSubtitle: "Modify and Review a Suggestion",
    addBookletSuggestion: "Add Suggestion",
    seTenantsEditorTitle: "Se-Tenants Editor",
    seTenantsEditorSubtitle: "Create a Se-Tenants Suggestion",
    seTenantsDetailsTitle: "Se-Tenants Details",
    seTenantsDetailsSuggestionSubtitle: "Details of a Se-Tenants Suggestion",
    seTenantsDetailsCatalogSubtitle: "Details of a Se-Tenants from the catalogue",
    seTenantsReviewTitle: "Se-Tenants Review Editor",
    seTenantsReviewSubtitle: "Modify and Review a Suggestion",
    addSeTenantsSuggestion: "Add Suggestion",
    done: "Done",
    selectStamps: "Select Stamps",
    stampInSetTitle: "Stamp in Set Editor",
    stampInSetSubtitle: "Create a stamp entry belonging to a set",
    accept: "Accept",
    reject: "Reject",
    addStampSuggestion: "Add Suggestion",
    addSetSuggestion: "Add Suggestion",
    addStampToSet: "Add Stamp to Set",
    moveStampUp: "Move stamp up",
    moveStampDown: "Move stamp down",
    removeStamp: "Remove stamp from set",
    removeStampConfirm: "Remove this stamp?",
    save: "Save",
    add: "Add",
    stamps: "Stamps",
  },
  fields: {
    title: "Title",
    titlePlaceholder: "title",
    description: "Description",
    descriptionPlaceholder: "description",
    issueDate: "Issue Date",
    expiryDate: "Expiry Date",
    clearExpiryDate: "Clear expiry date",
    size: "Size",
    printRun: "Print Run",
    width: "W",
    height: "H",
    mm: "mm",
    faceValue: "Face Value",
    faceValuePlaceholder: "0",
    selectUnit: "Select a unit",
    unit: "Unit",
    perforation: "Perforation",
    perforationType: "Type",
    selectType: "Select a type",
    horizontal: "H:",
    vertical: "V:",
    photoScan: "Photo/Scan",
    gum: {
      label: "Gum",
      unset: "Unknown",
      none: "Ungummed",
      dull: "Dull gum",
      glossy: "Glossy gum",
      adhesive: "Self-adhesive",
    },
    color: {
      label: "Colour",
      multiColored: "Multi-coloured",
      primary: "Primary colour",
      secondary: "Secondary colour",
    },
    perforationTypeLabels: {
      Imperforated: "Imperforated",
      Line: "Line",
      Comb: "Comb",
      Diecutting: "Diecutting",
    },
    securityPerforation: {
      label: "Security perforation",
      short: "Security perforation",
      button: "Security perforation",
      enabled: "Has a security perforation",
      shape: "Shape of the special hole",
      shapeText: "Name",
      shapeTextPlaceholder: "e.g. heart",
      holesPerSide: "Special holes per side",
      perSideShort: "side",
      scope: "Affected sides",
      innerSeparationOnly: "Inner separation only",
      innerSeparationOnlyShort: "inner separation only",
      position: "Position in the hole row",
      positionIndex: "Hole number",
      orientation: "Orientation of the major axis",
      dimensions: "Record measurement",
      diameter: "Diameter",
      majorAxis: "Major axis",
      minorAxis: "Minor axis",
      circumradius: "Circumradius",
      circumradiusShort: "circum.",
      inradius: "Inradius",
      inradiusShort: "in.",
      points: "Number of points",
      pointsShort: "points",
      shapes: {
        Round: "Circle",
        Ellipse: "Ellipse",
        Cross: "Cross",
        Star: "Star",
        Rhombus: "Rhombus",
        Motif: "Motif shape",
      },
      scopes: {
        AllFour: "all four sides",
        HorizontalOnly: "horizontal only",
        VerticalOnly: "vertical only",
      },
      positionLabels: {
        Center: "centred",
        Nth: "nth hole",
      },
      positions: {
        Center: "centred",
        Nth: "hole no. {n}",
      },
      orientations: {
        ParallelToRow: "parallel to the hole row",
        PerpendicularToRow: "perpendicular to the hole row",
      },
    },
  },
  list: {
    items: "Items",
    suggestions: "Suggestions",
    own: "Own",
    reviewOwned: "Review Owned",
    addStamp: "+ Stamp",
    addSet: "+ Set",
    addBlock: "+ Block",
    addBooklet: "+ Booklet",
    addSeTenants: "+ SeTenants",
    search: "Filter",
  },
  search: {
    title: "Search & Filter",
    description: "Filter the list by the selected criteria.",
    enabled: "enabled",
    disabled: "disabled",
    dateFrom: "Issue Date From",
    dateTo: "Issue Date To",
    ownOnly: "Suggested by me",
    reviewedByMe: "Review owned by me",
    descriptionWords: "Description Words",
    descriptionWordsPlaceholder: "word1 word2 ...",
    zhihaoPlaceholder: "e.g. 2018-2 or J.100",
    itemTypes: "Item Types",
    reviewStates: "Review States",
    reset: "Reset",
    dateFrom_short: "from",
    dateTo_short: "until",
    nTypes: "{n} types",
    singleStamp: "Single Stamp",
    stampFromSet: "Stamp from Set",
    reviewStateSuggested: "Suggested",
    reviewStateInReview: "In Review",
    reviewStateAccepted: "Accepted",
    reviewStateRejected: "Rejected",
  },
  review: {
    markAsInReview: "Mark as In Review",
    notInReview: "Not In Review",
    inReviewByOther: "In Review by someone else",
    inReviewByYou: "In Review by you",
    inReviewByYouClickToDrop: "In Review by you — click to drop the review",
    rejected: "Rejected",
  },
  buttons: {
    details: "Details",
    review: "Review",
    edit: "Edit",
    delete: "Delete",
    collapse: "Collapse",
    expand: "Expand",
  },
  deleteSuggestion: {
    title: "Delete Suggestion",
    subtitle: "Review the suggestion below before deleting.",
    warning: "Are you sure to delete this suggestion?",
    confirm: "Confirm Delete",
    cancel: "Cancel",
  },
  validation: {
    titleEmpty: "Title must not be empty",
    descriptionEmpty: "Description needs to be non-empty",
    dateNotSet: "Date of issue needs to be set",
    faceValueNotSet: "Face value needs to be set",
    faceValueZero: "Face value needs to be greater than 0",
    faceValueUnitNotSet: "Face value unit needs to be set",
    pictureNotSet: "A picture needs to be set",
    perforationTypeNotSet: "Perforation type needs to be set",
    perforationHorizontalZero: "Horizontal perforation count needs to be greater than 0",
    perforationVerticalZero: "Vertical perforation count needs to be greater than 0",
    securityHoleShapeNotSet: "The shape of the special hole must be set",
    securityHoleShapeTextMissing: "A motif shape needs a name",
    securityHoleCountInvalid: "The number of special holes per side must be greater than 0",
    securityHoleScopeNotSet: "The affected sides must be set",
    securityHolePositionIndexInvalid: "The hole number must be greater than 0",
    securityHoleOrientationNotSet: "The orientation of the major axis must be set",
    securityHoleDimensionsMismatch: "The recorded measurement does not match the chosen shape",
    securityHoleDimensionsIncomplete: "The measurement of the special hole is incomplete",
    securityHoleAxesSwapped: "The minor axis must not be larger than the major axis",
    securityHoleRadiiSwapped: "The inradius must not be larger than the circumradius",
    securityHoleStarPointsInvalid: "A star needs at least 3 points",
    noStampsSelected: "At least one stamp must be selected",
    noStampsInSet: "A set must contain at least one stamp",
    zhihaoPrefixUnknown: "Unknown Zhihao prefix",
    zhihaoIncomplete: "The Zhihao is incomplete",
    zhihaoPositionExceedsSetSize: "The position must not be greater than the set size",
  },
  catalogIds: {
    button: "Catalogues",
    clear: "Clear",
  },
  zhihao: {
    button: "Zhihao",
    clear: "Clear",
    prefix: "Prefix",
    year: "Year",
    series: "Issue no.",
    setSize: "Set size",
    position: "Position",
    preview: "Preview",
    showAll: "Show all prefixes",
    showMatching: "Only prefixes matching the date",
    epochMismatch: "This prefix does not belong to the era of the issue date",
    inheritedFromSet: "Inherited from the set",
    positionPerStamp: "The position is derived per stamp from its place in the set.",
    positionOnlyInSet: "A position within an issue is only assigned in the set editor.",
    epochs: {
      Early: "1949-1967",
      Wen: "1967-1970 (文)",
      Numbered: "1970-1973 (编号)",
      JT: "1974-1991 (J/T)",
      Biannian: "since 1992",
      Universal: "any era",
    },
    prefixLabels: {
      ji: "Commemorative (纪)",
      te: "Special (特)",
      gai: "Surcharged (改)",
      qian: "Postage due (欠)",
      jun: "Military (军)",
      hang: "Airmail (航)",
      wen: "Cultural Revolution (文)",
      numbered: "Numbered issue (编号)",
      J: "Commemorative (J)",
      T: "Special (T)",
      teSpecial: "Special issue (特)",
      he: "Greetings (贺)",
      ge: "Personalised (个)",
      fu: "Surcharge (附)",
      pu: "Definitive (普)",
      SB: "Booklet (SB)",
    },
  },
  labels: {
    button: "Categories",
    original_edition: "Original edition",
    reprint: "Reprint",
    exists_with_imprint_jp5: "Exists with imprint JP 5",
  },
  alt: {
    stamp: "Stamp",
    aStamp: "A Stamp",
  },
  mobile: {
    invalidTitle: "Invalid Link",
    invalidText: "This upload link is missing a token. Please scan the QR code again.",
    idleTitle: "Upload Photo",
    idleText: "Take a photo of the stamp or select an existing image.",
    choosePhoto: "📷 Choose / Take Photo",
    detectingTitle: "Analysing…",
    detectingText: "Detecting stamp boundaries.",
    cropTitle: "Adjust crop",
    cropText: "Drag the corners to refine.",
    retake: "↩ Retake",
    useCrop: "✓ Use this crop",
    uploadingTitle: "Uploading…",
    uploadingText: "Please wait.",
    successTitle: "✓ Photo received!",
    successText: "You can close this page and return to the editor.",
    errorTitle: "Upload failed",
    errorText: "Please go back and try again.",
  },
  registerUser: {
    title: "Register User",
    description: "Create a new user account.",
    name: "Name",
    namePlaceholder: "Full name",
    email: "Email",
    password: "Password",
    role: "Role",
    button: "Register",
    menuItem: "Register User",
    errorNameEmpty: "Name must not be empty.",
    errorEmailEmpty: "Email must not be empty.",
    errorPasswordEmpty: "Password must not be empty.",
    errorRoleNotSet: "A role must be selected.",
  },
  mode: {
    creatorMode: "Creator Mode",
    catalogMode: "Catalogue Mode",
  },
  orientation: {
    title: "Please rotate your device",
    message: "This catalogue is designed for portrait mode. Please hold your device upright.",
  },
  roles: {
    Viewer: "Viewer",
    Contributor: "Contributor",
    Reviewer: "Reviewer",
    Admin: "Admin",
  },
  upload: {
    chooseFile: "Choose File",
    replaceFile: "Replace File",
    addPhoto: "Add Photo",
    removePhoto: "Remove photo",
    button: "Upload from Phone",
    title: "Upload from Phone",
    description: "Scan the QR code with your phone to take or upload a photo.",
    waiting: "Waiting for photo…",
    generating: "Generating QR code…",
    validFor: "Valid for {s} seconds",
    expired: "QR code expired. Please close and reopen the dialog.",
    success: "Photo received!",
    error: "Upload failed.",
  },
};

export default en;
